/*** 
 * 點選頁籤時，將視窗高度移回頁籤原本高度
 */
export function goToTopSupport() {
  let tourPage_kv = document.querySelector(".tourPage_kv");
  let nav_box = document.querySelector(".nav_box");
  nav_box.addEventListener("click", function (event) {
    if (document.documentElement.scrollTop >= tourPage_kv.offsetHeight + 70) {
      var top = tourPage_kv.offsetHeight + 70;
      window.scrollTo({
        top: top,
        behavior: "smooth",
      });
    }
  });
}
